import React from 'react';
import {motion} from 'framer-motion';
import {clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

const GlowText=({children,className,color='cyan',as='h1'})=> {
  const Component=motion[as] || motion.h1;
  
  // Increased base opacities for better visibility
  const glowColors={
    cyan: 'rgba(34,211,238,0.7)',
    gold: 'rgba(251,191,36,0.7)',
    purple: 'rgba(192,132,252,0.7)',
    white: 'rgba(255,255,255,0.45)'
  };
  
  const shadowColor=glowColors[color] || glowColors.cyan;
  
  return (
    <Component 
      className={twMerge('relative z-10 font-bold tracking-tight',className)}
      initial={{opacity: 0,y: 20}}
      animate={{opacity: 1,y: 0}}
      transition={{duration: 0.8,ease: "easeOut"}}
      // Layered text shadows for a deeper, more visible glow
      style={{
        textShadow: `
          0 0 15px ${shadowColor},
          0 0 35px ${shadowColor},
          0 0 70px ${shadowColor.replace('0.7', '0.25')}
        `
      }}
    >
      <span className="relative z-10">{children}</span>
      {/* Increased backing opacity from 0.4 to 0.6 */}
      <span 
        className="absolute inset-0 blur-2xl opacity-60 z-[-1]" 
        aria-hidden="true" 
        style={{color: shadowColor}}
      >
        {children}
      </span>
    </Component>
  );
};

export default GlowText;